import React from 'react';
import { useDarkMode } from '../../context/DarkModeContext';
const TermsOfService = () => {
  const {
    darkMode
  } = useDarkMode();
  return <div className={`min-h-screen ${darkMode ? 'bg-gray-900 text-gray-100' : 'bg-gray-50 text-gray-900'} py-12`} data-id="element-10149" data-mp="280uxa9a7pt3y">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-10150" data-mp="2czoby518jq5p">
        <h1 className="text-3xl font-bold mb-2" data-id="element-10151" data-mp="2h2kkt40z47wg">Terms of Service</h1>
        <p className={`text-sm mb-8 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-10152" data-mp="1kdmp9jleg5y8">
          Last updated: October 25, 2023
        </p>

        <div className={`prose ${darkMode ? 'prose-invert' : ''} max-w-none`} data-id="element-10153" data-mp="1p9k5lpwnxcb0">
          <p data-id="element-10154" data-mp="1tc8fm0x44p9k">
            Please read these Terms of Service ("Terms") carefully before using
            the LitLaunch platform. By accessing or using our services, you
            agree to be bound by these Terms.
          </p>

          <h3 data-id="element-10155" data-mp="15nxk7da6rhso">1. Acceptance of Terms</h3>
          <p data-id="element-10156" data-mp="15mvzsi7a5iya">
            By accessing or using LitLaunch, you agree to be bound by these
            Terms and all applicable laws and regulations. If you do not agree
            with any of these Terms, you are prohibited from using or accessing
            this site.
          </p>

          <h3 data-id="element-10157" data-mp="19ge6iew56pz7">2. User Accounts</h3>
          <p data-id="element-10158" data-mp="19fbiceq7f1mz">
            When you create an account with us, you must provide information
            that is accurate, complete, and current. Failure to do so
            constitutes a breach of the Terms, which may result in immediate
            termination of your account.
          </p>

          <h3 data-id="element-10159" data-mp="vftqfqhm389e">3. Intellectual Property</h3>
          <p data-id="element-10160" data-mp="qi1xct58dg3m">
            The content, features, and functionality of LitLaunch are and will
            remain the exclusive property of LitLaunch and its licensors. Our
            trademarks and trade dress may not be used in connection with any
            product or service without the prior written consent of LitLaunch.
          </p>

          <h3 data-id="element-10161" data-mp="2fyjge9ofpi9n">4. User Content</h3>
          <p data-id="element-10162" data-mp="2fv5hxciw5t7h">
            Our service allows you to post, link, store, share and otherwise
            make available certain information, text, graphics, videos, or other
            material ("Content"). You are responsible for the Content that you
            post to the Service, including its legality, reliability, and
            appropriateness.
          </p>

          <h3 data-id="element-10163" data-mp="99r6f5aj6ryh">5. Termination</h3>
          <p data-id="element-10164" data-mp="96mwrsear40f">
            We may terminate or suspend your account immediately, without prior
            notice or liability, for any reason whatsoever, including without
            limitation if you breach the Terms.
          </p>

          <h3 data-id="element-10165" data-mp="n0w4i2y93c6p">6. Changes to Terms</h3>
          <p data-id="element-10166" data-mp="mzus9v5i0jne">
            We reserve the right, at our sole discretion, to modify or replace
            these Terms at any time. What constitutes a material change will be
            determined at our sole discretion.
          </p>
        </div>
      </div>
    </div>;
};
export default TermsOfService;